import { createActorContext } from '@xstate/react';
import { studioMachine } from '@ad3d/state-machine';

export const StudioContext = createActorContext(studioMachine);
